// @flow

import type { Action } from './store.type';

export const GET_VARIANTS_DISPLAY_REQUEST = 'GET_VARIANTS_DISPLAY_REQUEST';
type GET_VARIANTS_DISPLAY_REQUEST_TYPE = 'GET_VARIANTS_DISPLAY_REQUEST';

export const GET_VARIANTS_DISPLAY_SUCCESS = 'GET_VARIANTS_DISPLAY_SUCCESS';
type GET_VARIANTS_DISPLAY_SUCCESS_TYPE = 'GET_VARIANTS_DISPLAY_SUCCESS';

export const GET_VARIANTS_DISPLAY_FAILURE = 'GET_VARIANTS_DISPLAY_FAILURE';
type GET_VARIANTS_DISPLAY_FAILURE_TYPE = 'GET_VARIANTS_DISPLAY_FAILURE';

export const UPDATE_VARIANTS_DISPLAY_REQUEST = 'UPDATE_VARIANTS_DISPLAY_REQUEST';
type UPDATE_VARIANTS_DISPLAY_REQUEST_TYPE = 'UPDATE_VARIANTS_DISPLAY_REQUEST';

export const UPDATE_VARIANTS_DISPLAY_SUCCESS = 'UPDATE_VARIANTS_DISPLAY_SUCCESS';
type UPDATE_VARIANTS_DISPLAY_SUCCESS_TYPE = 'UPDATE_VARIANTS_DISPLAY_SUCCESS';

export const UPDATE_VARIANTS_DISPLAY_FAILURE = 'UPDATE_VARIANTS_DISPLAY_FAILURE';
type UPDATE_VARIANTS_DISPLAY_FAILURE_TYPE = 'UPDATE_VARIANTS_DISPLAY_FAILURE';

export const CHECK_MER_PRODUCT_ID_REQUEST = 'CHECK_MER_PRODUCT_ID_REQUEST';
type CHECK_MER_PRODUCT_ID_REQUEST_TYPE = 'CHECK_MER_PRODUCT_ID_REQUEST';

export const CHECK_MER_PRODUCT_ID_SUCCESS = 'CHECK_MER_PRODUCT_ID_SUCCESS';
type CHECK_MER_PRODUCT_ID_SUCCESS_TYPE = 'CHECK_MER_PRODUCT_ID_SUCCESS';

export const CHECK_MER_PRODUCT_ID_FAILURE = 'CHECK_MER_PRODUCT_ID_FAILURE';
type CHECK_MER_PRODUCT_ID_FAILURE_TYPE = 'CHECK_MER_PRODUCT_ID_FAILURE';

type VariantsDisplaySuccess = {
  data: Object
};

type VariantsDisplayFailure = {
  error: any
};
type GetVariantsDisplayRequestAction = Action<GET_VARIANTS_DISPLAY_REQUEST_TYPE, null>;

type GetVariantsDisplaySuccessAction = Action<
  GET_VARIANTS_DISPLAY_SUCCESS_TYPE,
  VariantsDisplaySuccess
>;

type GetVariantsDisplayFailureAction = Action<
  GET_VARIANTS_DISPLAY_FAILURE_TYPE,
  VariantsDisplayFailure
>;

type UpdateVariantsDisplayRequestAction = Action<UPDATE_VARIANTS_DISPLAY_REQUEST_TYPE, null>;

type UpdateVariantsDisplaySuccessAction = Action<
  UPDATE_VARIANTS_DISPLAY_SUCCESS_TYPE,
  VariantsDisplaySuccess
>;

type UpdateVariantsDisplayFailureAction = Action<
  UPDATE_VARIANTS_DISPLAY_FAILURE_TYPE,
  VariantsDisplayFailure
>;

type CheckMERProductIdRequestAction = Action<CHECK_MER_PRODUCT_ID_REQUEST_TYPE, null>;

type CheckMERProductIdSuccessAction = Action<
  CHECK_MER_PRODUCT_ID_SUCCESS_TYPE,
  VariantsDisplaySuccess
>;

type CheckMERProductIdFailureAction = Action<
  CHECK_MER_PRODUCT_ID_FAILURE_TYPE,
  VariantsDisplayFailure
>;

export type VariantsDisplayAction =
  | GetVariantsDisplayRequestAction
  | GetVariantsDisplaySuccessAction
  | GetVariantsDisplayFailureAction
  | UpdateVariantsDisplayRequestAction
  | UpdateVariantsDisplaySuccessAction
  | UpdateVariantsDisplayFailureAction
  | CheckMERProductIdRequestAction
  | CheckMERProductIdSuccessAction
  | CheckMERProductIdFailureAction;

export type VariantsDisplayState = {
  getLoading: boolean,
  updateLoading: boolean,
  success: boolean,
  error: any,
  VariantsDisplay: {},
  isExistsMERProductId: boolean
};
